import { render, staticRenderFns } from "./ListMotoristaCancelamentoCargaView.vue?vue&type=template&id=9d5f5eb4&"
import script from "./ListMotoristaCancelamentoCargaView.vue?vue&type=script&lang=ts&"
export * from "./ListMotoristaCancelamentoCargaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports